module.exports = __webpack_public_path__ + "img/home_image_banner@2x.9c119bad.png";